import React from "react";
import { Col, Row, CardText } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';


const FilterPreview = () => {
    const filterData = useSelector(state => state.filter);
    const { t } = useTranslation();
    return (
        <div className="bgGray p-3">
            <CardText tag="h6" className="py-2 font-size-16" style={{color:"#2b2a5e"}}>{t("Filtered by")}</CardText>
            <Row>
                {filterData?.location ? <Col className="pb-3" xl={3} lg={4} md={6}>
                    <CardText tag="h6"  className="font-size-14 text-muted"   >{t("location")}</CardText>
                    <CardText tag="h6" className="font-size-14 fw-bold" style={{color:"#3a3335"}}>{filterData?.ResaleLocation}</CardText>
                </Col> : null}
                {filterData?.unitType?.length ? <Col className="pb-3" xl={3} lg={4} md={6}>
                    <CardText tag="h6" className="font-size-14 text-muted" >{t("property type")}</CardText>
                    <CardText tag="h6" className="font-size-14 fw-bold" style={{color:"#3a3335"}}>{filterData?.unitType[0]?.label}</CardText>
                </Col> : null}
                {filterData?.size ? <Col className="pb-3" xl={3} lg={4} md={6}>
                    <CardText tag="h6" className="font-size-14 text-muted" >{t("size")}</CardText>
                    <CardText tag="h6" className="font-size-14 fw-bold" style={{color:"#3a3335"}}>{filterData?.size[0]} - {filterData?.size[1]}</CardText>
                </Col> : null}
                {filterData?.bedroom?.length ? <Col className="pb-3" xl={3} lg={4} md={6}>
                    <CardText tag="h6" className="font-size-14 text-muted" >{t("No. of Bedrooms")}</CardText>
                    <CardText tag="h6" className="font-size-14 fw-bold" style={{color:"#3a3335"}}>{filterData?.bedroom}</CardText>
                </Col> : null}
                {filterData?.bathroom?.length ? <Col className="pb-3" xl={3} lg={4} md={6}>
                    <CardText tag="h6" className="font-size-14 text-muted" >{t("No. of Bathrooms")}</CardText>
                    <CardText tag="h6" className="font-size-14 fw-bold" style={{color:"#3a3335"}}>{filterData?.bathroom}</CardText>
                </Col> : null}
                {filterData?.budget ? <Col className="pb-3" xl={3} lg={4} md={6}>
                    <CardText tag="h6" className="font-size-14 text-muted" >{t("budget")}</CardText>
                    <CardText tag="h6" className="font-size-14 fw-bold" style={{color:"#3a3335"}}>{filterData?.budget[0]} - {filterData?.budget[1]}</CardText>
                </Col> : null}
            </Row>
        </div>
    );
};

export default FilterPreview;
